import React, { useState, useContext } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import CloseButton from 'react-bootstrap/CloseButton';
import PulseLoader from "react-spinners/PulseLoader";
import useLocalStorage from "use-local-storage";
import { ShoppingCartContext, ShoppingCartProvider } from '../dealer/ShoppingCartContext';
import { useLocation } from 'react-router-dom';
import { Link, useNavigate } from 'react-router-dom';
export default function OrderSessionPopup({ show, handleShowCartClose }) {
    
    const navigate = useNavigate();

    const GoToOrderForm = async () => {
        if (window.location.pathname !== "/neworder") {
            navigate('/neworder');
        }
    }
    return (
        <Modal show={show} onHide={handleShowCartClose} dialogClassName="dealer-section" centered>
            <Modal.Header closeButton>
                <Modal.Title>EXISTING ORDER</Modal.Title>
                <CloseButton variant="white" data-bs-theme="dark" />
            </Modal.Header>

            <Modal.Body>
                <Row>
                    <Col sm={12}>
                        <p>There is an order in progress. Do you want to resume that order or start a new order?</p>
                    </Col>
                </Row>
            </Modal.Body>

            <Modal.Footer className="text-center">
                <Button variant="secondary" onClick={() => { debugger; GoToOrderForm(); handleShowCartClose(); }}>
                    <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                    </svg>
                    RESUME ORDER
                </Button>
                <Button variant="primary" onClick={() => { localStorage.removeItem('shoppingcart'); navigate("/neworder"); window.location.reload(); }}>
                    <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                    </svg>
                    NEW ORDER
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

